import { RouterProvider, createBrowserRouter } from "react-router-dom"
import { AuthProvider, useAuth, login, refresh, getUserData, getTokenExpireDate, getRefreshExpireDate } from "./auth"
import { DataFetchingAuthContext } from "@inmagik/react-crud"
import DataProvider from "./DataProvider"
import { Navigation } from "./Navigation"

function ProvideAuthToDataFetching({ children }: { children: React.ReactNode }) {
  const { tokens } = useAuth()

  const authHeaders: Record<string, string> = tokens?.access ? { Authorization: `Bearer ${tokens?.access}` } : {}

  return <DataFetchingAuthContext.Provider value={authHeaders}>{children}</DataFetchingAuthContext.Provider>
}

const router = createBrowserRouter([{ path: "*", element: <Root /> }])

function App() {
  return <RouterProvider router={router}></RouterProvider>
}

function Root() {
  return (
    <AuthProvider
      login={login}
      refresh={refresh}
      getUserData={getUserData}
      getTokenExpireDate={getTokenExpireDate}
      getRefreshExpireDate={getRefreshExpireDate}
    >
      <ProvideAuthToDataFetching>
        <DataProvider>
          <Navigation></Navigation>
        </DataProvider>
      </ProvideAuthToDataFetching>
    </AuthProvider>
  )
}

export default App
